/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

// AWS Constants
export const AWS_DOWNLOAD_TEMPLATE_ERR = `AWS onboarding template could not be generated.`;
export const AWS_INFO_EXTERNAL_ID = `For security reasons External ID is forced to be a tenant ID and shouldn't be modified by the user.`;
export const AWS_INFO_ONBOARDING = `
For on-boarding process, each account needs to have an IAM role created with read only permissions and trust relationship set to Nordcloud's AWS account. For your convenience, please use provided Cloudformation template. There is no requirement for deployment region, but we recommend eu-west-1.`;

// Azure Constants
export const AZURE_DOWNLOAD_SCRIPT_ERR = `Azure onboarding script could not be generated.`;
export const AZURE_INFO_ONBOARDING = `To on-board a subscription you need to create a Service Principal.`;
export const AZURE_SUB_PLACEHOLDER = "291bba3f-e0a5-47bc-a099-3dbcb2a50a05";

// Shared account details placeholders
export const ACCOUNT_NAME_PLACEHOLDER =
  "Application Name, Environment Name, etc.";
export const ACCOUNT_DESCRIPTION_PLACEHOLDER = "Provide Account Description";
export const ACCOUNT_ENVIRONMENT_PLACEHOLDER = "Provide Environment";

// Google Cloud Constants
export const GOOGLE_INFO_ONBOARDING = `To on-board a project you need to create a Service Account.`;
export const GOOGLE_PROJECT_ID_PLACEHOLDER = "Project-Id";
export const GOOGLE_KEY_FILE = "Upload service account key json file";
export const GOOGLE_REQUIRED_APIS = [
  "IAM Service Account Credentials API",
  "Compute Engine API",
];

// IBM Cloud Constants
export const IBM_INFO_ONBOARDING =
  "To on-board an IBM Cloud account, provide the account ID and an API key for the account.";

// URLs
export const URL_AWS_CONSOLE = "https://console.aws.amazon.com/console/home";
export const URL_AWS_EXTERNAL_IDS =
  "https://aws.amazon.com/blogs/security/how-to-use-external-id-when-granting-access-to-your-aws-resources/";
export const URL_AZURE_CONSOLE = "https://portal.azure.com";
export const URL_GOOGLE_APIS_LIBRARY =
  "https://console.cloud.google.com/apis/library/browse?filter=category:enterprise-api";
export const URL_GOOGLE_CONSOLE = "https://console.cloud.google.com";
export const URL_GOOGLE_IAM = "https://console.cloud.google.com/iam-admin/iam";
export const URL_GOOGLE_SERVICE_ACCOUNTS =
  "https://console.cloud.google.com/iam-admin/serviceaccounts";
export const URL_IBM_CLOUD_PLATFORM = "https://cloud.ibm.com/login";

// Sections
export const ACCOUNT_CREDENTIALS_SECTION = "Account Credentials";
